import snakeCase from 'lodash/snakeCase';
import reduce from 'lodash/reduce';
import toString from 'lodash/toString';
import { DfpTargeting } from './types';
import { DFP_TARGETING_DEFAULTS } from './constants';

type looseObject = {
    [k: string]: any; //eslint-disable-line  @typescript-eslint/no-explicit-any
};

type RawFilterFieldName = string | null;
type RawFilterOptions = null | (string | null)[];
type RawFilterValue = string | null | [] | boolean;

type RawFilter = {
    group: string | null;
    fieldName: RawFilterFieldName;
    label: string | null;
    isRequired: boolean | null;
    inputType: string | null;
    placeholder: string | null;
    allowMultiple: boolean | null;
    options: RawFilterOptions;
    value: RawFilterValue;
};

// Fix occasional issue whereby the outcodes array does not include the outcode
const coerceOutcodes = (targetingObj: DfpTargeting): DfpTargeting => {
    const outcodes = targetingObj['outcodes'] || [];
    if (
        Array.isArray(outcodes) &&
        typeof targetingObj['outcode'] === 'string' &&
        !outcodes.includes(targetingObj['outcode'])
    ) {
        return {
            ...targetingObj,
            outcodes: [...outcodes, targetingObj['outcode']]
        };
    }
    return targetingObj;
};

const coerceKeyValPairs = (obj: looseObject) =>
    reduce(
        obj,
        (result, value, key) => {
            result[snakeCase(toString(key))] = Array.isArray(value)
                ? value.map(toString)
                : toString(value);
            return result;
        },
        {} as DfpTargeting
    );

export const coerceDfpAdTargetingObject = (
    targetingObject?: looseObject | null
): DfpTargeting => {
    const safelyTypedObj = targetingObject
        ? coerceKeyValPairs({ ...targetingObject })
        : {};
    return coerceOutcodes(safelyTypedObj);
};

export const mapTargetingFilters = (rawFilters: RawFilter[]) => {
    const filters = rawFilters.reduce((obj, item) => {
        return item.value != null
            ? {
                  ...obj,
                  [snakeCase(toString(item.fieldName))]: toString(item.value)
              }
            : obj;
    }, {} as DfpTargeting);

    // set defaults if empty
    return {
        ...DFP_TARGETING_DEFAULTS,
        ...filters
    };
};
